import React from 'react'

const DoctorList = () => {
  return (
    <div>
      list
    </div>
  )
}

export default DoctorList
